<template>
  <div class="c-product-list">
    <div class="c-product-list__title">
      Linkkap企业价值管理系统
    </div>
    <div class="c-product-list__warp">
      <div
        :style="`overflow: hidden; margin-bottom: -0.4rem; max-height: ${productOpen ? 'none' : '4rem'}`"
      >
        <div
          v-for="(group, groupIndex) in productList"
          :key="groupIndex"
          class="c-product-list__row"
        >
          <product-item
            v-for="(item, index) in group"
            :key="index"
            :item="item"
            @click-item="clickItem"
          />
        </div>
      </div>
      <div v-if="productList.length > 3" class="p-my-product__item__arrow">
        <span :class="{'p-my-product__item__up': productOpen}" @click="changeArrow">{{ productOpen ? '收起所有' : '展开剩余' }} <a-icon class="p-my-product__item__arrow-icon" type="down" /></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ProductItem from '@/components/product-item'
export default {
  components: {
    ProductItem
  },
  data() {
    return {
      productOpen: false,
    }
  },
  computed: {
    ...mapState({
      appInfo: state => state.product.appInfo,
    }),
    productList() {
      const standardList = [].concat(this.appInfo.standard || [])
      const resultList = []
      while (standardList.length) {
        resultList.push(standardList.splice(0, 2))
      }
      return resultList
    }
  },
  methods: {
    changeArrow() {
      this.productOpen = !this.productOpen
    },
    clickItem(item) {
      this.$emit('click-item', item)
    },
  }
}
</script>

<style lang="scss">
.c-product-list {
  background-color: #fff;
  padding: 0.26rem;
  .c-product-list__title {
    font-size: 16px;
    font-weight: bold;
  }
  .c-product-list__warp {
    padding: 0.4rem 0.2rem 0.2rem;
    max-width: 1124px;
    .c-product-list__row {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: 0.4rem;
      .p-my-product__item {
        position: relative;
        margin-bottom: 0;
      }
    }
    .c-product-list__row::after {
      position: absolute;
      content: "";
      width: 1px;
      left: 50%;
      top: 10%;
      height: 80%;
      border-left: 2px solid #f6f6f6;
    }
  }
  .p-my-product__item__arrow {
    color: #108EE9;
    line-height: 0.25rem;
    text-align: center;
    cursor: pointer;
    margin-top: 0.4rem;
  }
  .p-my-product__item__arrow-icon {
    position: relative;
    font-size: 12px;
  }
  .p-my-product__item__up .p-my-product__item__arrow-icon {
    transform: rotate(180deg);
  }
}
</style>
